import { Pipe, PipeTransform } from '@angular/core';

import { IAssetGateway } from '@lib/asset-gateway.interface';
import { CHECK_IN_RATE_KEYS } from '@lib/asset-gateway.consts';
import { EVERY_12_HOURS_TEXT, convertAG31UpdateRateValue, isModelAG55 } from '@lib/asset-gateway.utils';

interface IAG31CheckInRate {
  locationUpdateFrequency?: number;
  frequentlocationUpdateRate?: number;
  isMotionDetectionEnabled?: boolean;
}

@Pipe({ name: 'agCheckInRate' })
export class AGCheckInRatePipe implements PipeTransform {
  public transform(assetGateway: IAssetGateway, key: CHECK_IN_RATE_KEYS): string {
    let timeText: string;
    let checkInRateValue: number;
    const isAssetGatewayModel55: boolean = assetGateway?.model && isModelAG55(assetGateway);
    const { locationUpdateFrequency, frequentlocationUpdateRate, isMotionDetectionEnabled }: IAG31CheckInRate = assetGateway;

    if (key === CHECK_IN_RATE_KEYS.CHECK_IN) {
      if (isAssetGatewayModel55) return EVERY_12_HOURS_TEXT;
      else {
        checkInRateValue = convertAG31UpdateRateValue(locationUpdateFrequency);
        timeText = this.getTimeText(checkInRateValue);
        return $localize`Every ${checkInRateValue} ${timeText}`;
      }
    } else if (key === CHECK_IN_RATE_KEYS.ADDITIONAL_CHECK_IN) {
      if (!isMotionDetectionEnabled) return $localize`Off`;
      else {
        if (!frequentlocationUpdateRate) return $localize`When the asset starts or stops moving`;
        else {
          checkInRateValue = convertAG31UpdateRateValue(frequentlocationUpdateRate);
          timeText = this.getTimeText(checkInRateValue);
          return $localize`Every ${checkInRateValue} ${timeText} while the asset is in motion`;
        }
      }
    } else return '';
  }

  private getTimeText(time: number): string {
    if (time > 1) return $localize`hours`;
    else if (time === 1) return $localize`hour`;
  }
}
